/*-----------------------------------------------------------------
- Languages
-----------------------------------------------------------------*/
export default {

    years  : 'سال',
    months : 'ماه',
    days   : 'روز',
    hours  : 'ساعت',
    minutes: 'دقیقه',
    seconds: 'ثانیه',

};
